module.exports = __webpack_public_path__ + "assets/expenses.f27fd9af.svg";